import { API_USER_SERVICE } from "../config/Constants";
import { IChangePasswordDTO, IUpdateUserDTO } from "../interfaces/UserProfile";
import { getRequest, putRequest } from "./Rest";
import axios from "axios";

export const getUserProfile = async () => {
    const path = `${API_USER_SERVICE}/user/profile`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const changePassword = async (dto: IChangePasswordDTO) => {
    const path = `${API_USER_SERVICE}/user/change-password`;
    const response = await putRequest(path, dto);
    return response;
};

export const updateUserProfile = async (targetUserId: number, dto: IUpdateUserDTO, profileImage?: File) => {
    const path = `${API_USER_SERVICE}/user/update/${targetUserId}`;
    
    if (profileImage) {
        const formData = new FormData();
        formData.append("data", new Blob([JSON.stringify(dto)], { type: "application/json" }));
        formData.append("profileImage", profileImage);
        
        const token = sessionStorage.getItem("token");
        const response = await axios.put(path, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    } else {
        const formData = new FormData();
        formData.append("data", new Blob([JSON.stringify(dto)], { type: "application/json" }));
        
        const token = sessionStorage.getItem("token");
        const response = await axios.put(path, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
        });
        return response.data;
    }
};